module.exports = __webpack_public_path__ + "static/media/gradient-background.41ac3734.svg";